<!--<div class="drop">-->
    <!--<p class="currency-format-label">-->
        <!--{{digitsToTrim == 0 ? 'Full value' : 'Round off to thousands'}}-->
        <!--<i class="material-icons" style="vertical-align: middle">arrow_drop_down</i>-->
    <!--</p>-->
    <!--<ul>-->
        <!--<li>-->
            <!--<a (click)="setCurrencyDigitsToTrim(0)"><input type="radio" [checked]="digitsToTrim === 0">Full value</a>-->
        <!--</li>-->
        <!--<li>-->
            <!--<a (click)="setCurrencyDigitsToTrim(3)">-->
                <!--<input type="radio" [checked]="digitsToTrim === 3">Round off to thousands-->
            <!--</a>-->
        <!--</li>-->
    <!--</ul>-->
<!--</div>-->

<app-select2
    [data]="currencyOptions"
    [options]="{minimumResultsForSearch: -1, containerCssClass: 'green'}"
    [value]="digitsToTrim"
    (valueChanged)="setCurrencyDigitsToTrim($event.value)"
    [width]="'168px'"
>
</app-select2>
